import React, { useState } from 'react';

export default function CVLogin({ onSubmit }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ username, password });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <h2 className="text-3xl font-semibold text-center text-white">Clyne Caravan Booking System</h2>
      <div>
        <label htmlFor="username" className="block mb-1 text-white font-medium">Username</label>
        <input
          id="username"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full px-4 py-2 rounded-md bg-white bg-opacity-80 focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Enter your username"
          required
        />
      </div>
      <div>
        <label htmlFor="password" className="block mb-1 text-white font-medium">Password</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-2 rounded-md bg-white bg-opacity-80 focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Enter your password"
          required
        />
      </div>
      <button
        type="submit"
        className="w-full py-2 rounded-md bg-blue-600 hover:bg-blue-700 transition text-white font-semibold"
      >
        Log In
      </button>
    </form>
)}